module.exports = __webpack_public_path__ + "static/media/react.95eef8bb.svg";